import Product from "@/entities/Product";
import Reseller from "@/entities/Reseller";
import axios from "axios";
import productsCache from '../assets/cache/products.json';
import resellersCache from '../assets/cache/resellers.json';
import eventsCache from '../assets/cache/events.json';
import Evento from "@/entities/Evento";
import YoutubeVideo from "@/entities/YoutubeVideo";

class ApiService {
    constructor(baseUrl, useCache = false, cdnUrl = null) {
        this.baseUrl = baseUrl;
        this.useCache = useCache;
        this.getImageBaseUrl = () => cdnUrl ?? (this.useCache ? '' : this.baseUrl);
    }

    async getProduct(id) {
        let product = null;
        if(this.useCache) {
            product = productsCache.find(p => p.id === parseInt(id));
        } else {
            const res = await axios.get(`${this.baseUrl}/prodotti-masticandos/${id}`);
            product = res.data;
        }
        if(!product) {
           return null;
        }
        return new Product(product, this.getImageBaseUrl(), !this.useCache);
    }

    async getProducts() {
        let products = [];

        if(this.useCache) {
            products = productsCache;
        } else {
            const res = await axios.get(`${this.baseUrl}/prodotti-masticandos`);
            products = res.data;
        }

        return products.map(p => new Product(p, this.getImageBaseUrl(), !this.useCache));
    }

    // async getHomePageContent() {
    //     const res = await axios.get(`${this.baseUrl}/home-page-masticando`);
    //     return res.data;
    // }
    async getResellers() {
        let resellers = [];

        if(this.useCache) {
            resellers = resellersCache;
        } else {
            const res = await axios.get(`${this.baseUrl}/resellers`);
            resellers = res.data;
        }
        return resellers.map(x => new Reseller(x, !this.useCache));
    }
    async getEvents() {
        let events = [];

        if(this.useCache) {
            events = eventsCache;
        } else {
            const res = await axios.get(`${this.baseUrl}/eventis`);
            events = res.data;
        }
        return events.map(x => new Evento(x, this.getImageBaseUrl()));
    }

    async getIoSonoCaneVideos() {
      let videos = [];
      const res = await axios.get(`${this.baseUrl}/io-sono-cane-videos`);
      videos = res.data;
      return videos.map(x => new YoutubeVideo(x));
    }
}
const apiService = new ApiService('https://strapi.fiveamtech.it', false, 'https://strapi.fiveamtech.it')
//const apiService = new ApiService('http://localhost:3000', true);
export default apiService;